import { Button, Drawer, theme } from '@acorns/web-components'
import styled from 'styled-components'

import { RECAP_XS_BREAKPOINT, fonts } from '../styles'

export const StyledModalDrawer = styled(Drawer)`
  padding-bottom: 10px;
  width: 100%;
`

export const ModalContent = styled.div`
  color: ${theme.colors.slate};
  margin-top: -40px;
`

export const ModalHeader = styled.h2`
  ${fonts.AN_22_600_30};
  margin-bottom: 20px;
  padding-right: 40px;
`

export const ModalText = styled.p`
  ${fonts.AN_14_600_22};
  font-weight: 400;
  margin-bottom: 10px;
  padding-right: 40px;

  &:last-child {
    margin-bottom: 30px;
  }
`

export const ModalSubtext = styled.p`
  ${fonts.AN_12_500_16};
  font-weight: 400;
  margin-bottom: 40px;
`

export const ButtonWrapperRowGrid = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr;
  row-gap: 10px;

  & button {
    width: 100%;
  }
`

export const ButtonWrapperColGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;

  & button {
    width: 100%;
  }
`

export const BlackButton = styled(Button)`
  margin-bottom: 30px;

  span {
    margin-left: 12px;
  }

  path {
    fill: ${theme.colors.white};
  }
`

export const WhiteButton = styled(Button)`
  width: 100%;
`

export const MobileShareButtonWrapper = styled.div`
  display: none;
  width: 100%;
  padding: 0 50px;

  @media screen and (max-width: ${RECAP_XS_BREAKPOINT}px) {
    display: initial;
    padding: 0 30px 30px;
    width: 100%;
  }
`
